/**
 * Base entity model. All Apollon models should inherit this class.
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { Foerderkategorie } from './Foerderkategorie';
import { createModel, type MutationsObject } from '@kp/js-model';

export class FoerderkategorieGruppe extends BaseModel {
    id: number | null = null
    bezeichnung: string | null = null
    hilfetext: string | null = null
    reihenfolge: number | null = null
    kategorien: Foerderkategorie[] | null = []

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            kategorien: (kats: Foerderkategorie[] | null) => (kats ? kats.map((k) => createModel(Foerderkategorie, k)) : [])
        };
    }

    getClassName(): string {
        return 'foerderkategorieGruppe';
    }
}
